import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Predictive Analytics"
                    description="Harness the power of your historical data to anticipate future trends and outcomes. Our advanced predictive analytics solutions empower businesses to make data-driven decisions, improve operational efficiency, and stay ahead of the competition. By leveraging machine learning models, we help you uncover actionable insights, optimize resource allocation, and boost profitability."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Natural Language Processing (NLP)"
                    description="Bridge the gap between human language and machine understanding with our cutting-edge NLP services. Whether it's building chatbots, performing sentiment analysis, or automating text classification, we enable your systems to understand, interpret, and respond to human language effectively."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Image and Video Recognition"
                    description="Unlock the potential of visual data with our state-of-the-art image and video recognition technologies. From automatic object detection to facial recognition, we provide robust solutions that enable businesses to gain insights and drive innovation through computer vision."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Recommendation Systems"
                    description="Deliver personalized user experiences with intelligent recommendation engines. By analyzing user behavior and preferences, we create tailored suggestions that enhance engagement, increase conversions, and foster customer loyalty."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Anomaly Detection"
                    description="Protect your business from unexpected events and fraudulent activities with our anomaly detection solutions. By identifying unusual patterns in data, we help mitigate risks, ensure operational stability, and secure your assets."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="Chatbots & Virtual Assistants"
                    description="Enhance customer interactions with our AI-powered chatbots and virtual assistants. Designed to deliver intelligent, real-time support, our solutions improve user experience, increase engagement, and streamline business operations."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
